/**
 * Question World Module - MathJax Component
 * Renders LaTeX/KaTeX math expressions
 */

import React from 'react';
import Latex from 'react-latex';

const MathInput = ({ mathItem }) => {
    return <Latex>{mathItem}</Latex>;
};

export default MathInput;

